<template>
<v-card class="card-custom" flat height="100%" max-height="470px" style="overflow-y: auto">
    <v-card-text>
        <div>
            <v-row align="center" class="search-bar-facilities">
                <v-col md="6" cols="12">
                    <v-text-field class="ma-0 pa-0" v-model="search" clearable :placeholder="$t('room_type.facilities.search_placeholder')" append-icon="search"></v-text-field>
                </v-col>
                <v-col md="6" cols="12" v-if="!show_main&&!search">
                    <div class="d-flex justify-end">
                        <v-btn color="primary" @click="show_main = !show_main, search = null">
                            <span>{{ $t('room_type.facilities.button.show_less') }}</span>
                        </v-btn>
                    </div>
                </v-col>
            </v-row>

            <v-row v-if="show_main" align="center">
                <v-col v-if="!this.$route.params.id" cols="12" class="headline py-2" style="color: #4A4A4A">
                    {{ $t('room_type.facilities.main_facilities') }}
                </v-col>
                <v-col v-else cols="12" class="headline py-2" style="color: #4A4A4A">
                    {{ $t('room_type.facilities.selected_facilities') }}
                </v-col>
                <v-col md="3" sm="6" cols="12" v-for="(item,index) in showMainFacilities()" :key="item.id" class="py-0">
                    <v-checkbox class="im-check-box ma-0 pa-0" v-model="selected_ids" :label="$t('room-facilities.'+ item.slug)" :value="item.id" color="primary" />
                </v-col>
            </v-row>
            <v-row v-else>
                <v-col md="3" sm="6" cols="12" v-for="(item,index) in filterFacilities()" :key="item.id" class="py-0">
                    <v-checkbox class="im-check-box ma-0 pa-0" v-model="selected_ids" :label="$t('room-facilities.'+ item.slug)" :value="item.id" color="primary" />
                </v-col>
            </v-row>

            <div class="d-flex justify-end">
                <v-btn v-show="show_main" color="primary" @click="show_main = !show_main, search = null">
                    <span v-if="show_main">{{ $t('room_type.facilities.button.show_more') }}</span>
                    <span v-else>{{ $t('room_type.facilities.button.show_less') }}</span>
                </v-btn>
            </div>
        </div>

    </v-card-text>

</v-card>
</template>

<script>
import {
    mapActions
} from 'vuex';

export default {
    props: {
        selected_facilities_ids: Array,
        active: Object,
        room_facilities: Array
    },
    name: `room-facilities`,
    components: {},
    data() {
        return {
            show_main: true,
            main_facilities: [15, 18, 24, 69, 89, 65, 110, 68, 127, 129, 132, 128, 134, 136],
            dialog_price_faciliy: false,
            // room_facilities: [],

            selected_ids: this.selected_facilities_ids,
            selected_facilities: {},
            search: null,
        };
    },

    created() {},

    watch: {
        selected_ids: {
            handler() {
                this.$emit('updateFacilities', this.selected_ids);
            }
        },
        selected_facilities_ids: {
            handler() {
                this.selected_ids = this.selected_facilities_ids;
            }
        },
        search: {
            handler() {
                if(this.search === null || this.search === undefined || this.search === "") {
                    this.show_main = true
                } else {
                    this.show_main = false;
                }
            }
        },
    },

    computed: {},

    methods: {

        ...mapActions('alert', ['success', 'error']),

        filterFacilities() {
            let locale_facilities = this.$i18n.messages[this.$i18n.locale]['room-facilities'];
            let keys = Object.keys(locale_facilities)
                .filter(function (key) {
                    if(locale_facilities[key].toLowerCase()
                        .includes(this.search || '')) {
                        return key
                    }
                }.bind(this));

            let items = this.room_facilities.filter(e => {
                return keys.includes(e.slug)
            })
            return items
        },

        showMainFacilities() {
            let items = [];
            if(this.$route.params.id) {
                items = this.room_facilities.filter(e => {
                    return this.selected_ids.includes(e.id) || this.main_facilities.includes(e.id)
                })
            } else {
                items = this.room_facilities.filter(e => {
                    return this.main_facilities.includes(e.id)
                })
            }
            return items
        },
    },

};
</script>
<style lang="stylus">
.search-bar-facilities
    position: sticky
    top: -12px
    background-color: white
    z-index: 3
</style>
